import { Routes } from '@/api/routes';
import { Errors } from '@/constants/errors';
import { apiClient } from '@/services/apiClient';
import type { PaymentToServerResponse } from '@/types/payment';
import { useMutation } from '@tanstack/react-query';

export const usePaymentToServer = () => {
  return useMutation({
    mutationFn: async (params: unknown) => {
      try {
        const response = await apiClient.post<PaymentToServerResponse>(
          Routes.PAYMENT,
          params as Record<string, unknown>
        );
        if (!response || 'error' in response) {
          throw new Error(Errors.global.failedToSendPayment);
        }
        return response;
      } catch (error: unknown) {
        throw new Error(Errors.global.failedToSendPayment, { cause: error });
      }
    },
  });
};
